// React
import React from "react";
import classNames from "classnames";
// Containers
import FlexContainer from "common/ui/containers/flexContainer/FlexContainer";
import FlexItem from "common/ui/containers/flexContainer/FlexItem";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./DataBar.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class DataBarSet extends React.Component {
    render() {
        let { flex, title } = this.props;
        return (React.createElement(FlexItem, { className: classNames(styles.dataBarSet), flexFactor: flex },
            React.createElement("span", { className: styles.title }, title),
            React.createElement(FlexContainer, null, this.props.children)));
    }
}
